var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"space-top"},[_c('img',{staticClass:"mt-3 w-100",attrs:{"src":require("@/assets/img/banner.png"),"alt":"logo-salute"}})])])
}]

export { render, staticRenderFns }